import MNPG_001 from "./components/MNPG_001";
import MNPG_002 from "./components/MNPG_002";
import MNPG_003 from "./components/MNPG_003";
import MNPG_004 from "./components/MNPG_004";
import MNPG_005 from "./components/MNPG_005";
import MNPG_006 from "./components/MNPG_006";
import MNPG_007 from "./components/MNPG_007";
import MNPG_008 from "./components/MNPG_008";
import MNPG_009 from "./components/MNPG_009";
import MNPG_010 from "./components/MNPG_010";
import MNPG_011 from "./components/MNPG_011";
import MNPG_012 from "./components/MNPG_012";
import MNPG_013 from "./components/MNPG_013";
import MNPG_014 from "./components/MNPG_014";
import MNPG_015 from "./components/MNPG_015";
import MNPG_016 from "./components/MNPG_016";
import MNPG_017 from "./components/MNPG_017";
import MNPG_018 from "./components/MNPG_018";
import MNPG_019 from "./components/MNPG_019";
import MNPG_020 from "./components/MNPG_020";
import MNPG_021 from "./components/MNPG_021";
import MNPG_022 from "./components/MNPG_022";
import MNPG_023 from "./components/MNPG_023";
import MNPG_024 from "./components/MNPG_024";
import MNPG_025 from "./components/MNPG_025";
import MNPG_026 from "./components/MNPG_026";
import MNPG_027 from "./components/MNPG_027";
import MNPG_028 from "./components/MNPG_028";
import MNPG_029 from "./components/MNPG_029";
import MNPG_033 from "./components/MNPG_033";
import MNPG_034 from "./components/MNPG_034";
import MNPG_035 from "./components/MNPG_035";
import MNPG_036 from "./components/MNPG_036";
import MNPG_037 from "./components/MNPG_037";
import MNPG_038 from "./components/MNPG_038";
import MNPG_039 from "./components/MNPG_039";
import MNPG_040 from "./components/MNPG_040";
import MNPG_041 from "./components/MNPG_041";
import MNPG_042 from "./components/MNPG_042";
import MNPG_043 from "./components/MNPG_043";
import MNPG_044 from "./components/MNPG_044";
import MNPG_045 from "./components/MNPG_045";
import MNPG_046 from "./components/MNPG_046";
import MNPG_047 from "./components/MNPG_047";
import MNPG_048 from "./components/MNPG_048";
import MNPG_049 from "./components/MNPG_049";
import MNPG_050 from "./components/MNPG_050";
import MNPG_051 from "./components/MNPG_051";
import MNPG_052 from "./components/MNPG_052";
import MNPG_053 from "./components/MNPG_053";
import MNPG_054 from "./components/MNPG_054";
import MNPG_055 from "./components/MNPG_055";
import MNPG_056 from "./components/MNPG_056";
import MNPG_057 from "./components/MNPG_057";
import MNPG_058 from "./components/MNPG_058";
import MNPG_059 from "./components/MNPG_059";
import MNPG_060 from "./components/MNPG_060";
import MNPG_061 from "./components/MNPG_061";
import MNPG_062 from "./components/MNPG_062";
import MNPG_063 from "./components/MNPG_063";
import MNPG_064 from "./components/MNPG_064";
import MNPG_065 from "./components/MNPG_065";
import MNPG_066 from "./components/MNPG_066";
import MNPG_067 from "./components/MNPG_067";
import MNPG_068 from "./components/MNPG_068";
import MNPG_069 from "./components/MNPG_069";
import MNPG_070 from "./components/MNPG_070";
import MNPG_071 from "./components/MNPG_071";


const MainPageLayouts:any = {
    
    MNPG_001,
    MNPG_002,
    MNPG_003,
    MNPG_004,
    MNPG_005,
    MNPG_006,
    MNPG_007,
    MNPG_008,
    MNPG_009,
    MNPG_010,
    MNPG_011,
    MNPG_012,
    MNPG_013,
    MNPG_014,
    MNPG_015,
    MNPG_016,
    MNPG_017,
    MNPG_018,
    MNPG_019,
    MNPG_020,
    MNPG_021,
    MNPG_022,
    MNPG_023,
    MNPG_024,
    MNPG_025,
    MNPG_026,
    MNPG_027,
    MNPG_028,
    MNPG_029,
    MNPG_033,
    MNPG_034,
    MNPG_035,
    MNPG_036,
    MNPG_037,
    MNPG_038,
    MNPG_039,
    MNPG_040,
    MNPG_041,
    MNPG_042,
    MNPG_043,
    MNPG_044,
    MNPG_045,
    MNPG_046,
    MNPG_047,
    MNPG_048,
    MNPG_049,
    MNPG_050,
    MNPG_051,
    MNPG_052,
    MNPG_053,
    MNPG_054,
    MNPG_055,
    MNPG_056,
    MNPG_057,
    MNPG_058,
    MNPG_059,
    MNPG_060,
    MNPG_061,
    MNPG_062,
    MNPG_063,
    MNPG_064,
    MNPG_065,
    MNPG_066,
    MNPG_067,
    MNPG_068,
    MNPG_069,
    MNPG_070,
    MNPG_071

}

export type TMainPageLayouts = 
    'MNPG_001'|'MNPG_002'|'MNPG_003'|'MNPG_004'|'MNPG_005'|'MNPG_006'|'MNPG_007'|'MNPG_008'|'MNPG_009'|'MNPG_010'|
    'MNPG_011'|'MNPG_012'|'MNPG_013'|'MNPG_014'|'MNPG_015'|'MNPG_016'|'MNPG_017'|'MNPG_018'|'MNPG_019'|'MNPG_020'|
    'MNPG_021'|'MNPG_022'|'MNPG_023'|'MNPG_024'|'MNPG_025'|'MNPG_026'|'MNPG_027'|'MNPG_028'|'MNPG_029'|'MNPG_030'|
    'MNPG_031'|'MNPG_032'|'MNPG_033'|'MNPG_034'|'MNPG_035'|'MNPG_036'|'MNPG_037'|'MNPG_038'|'MNPG_039'|'MNPG_040'|
    'MNPG_041'|'MNPG_042'|'MNPG_043'|'MNPG_044'|'MNPG_045'|'MNPG_046'|'MNPG_047'|'MNPG_048'|'MNPG_049'|'MNPG_050'|
    'MNPG_051'|'MNPG_052'|'MNPG_053'|'MNPG_054'|'MNPG_055'|'MNPG_056'|'MNPG_057'|'MNPG_058'|'MNPG_059'|'MNPG_060'|
    'MNPG_061'|'MNPG_062'|'MNPG_063'|'MNPG_064'|'MNPG_065'|'MNPG_066'|'MNPG_067'|'MNPG_068'|'MNPG_069'|'MNPG_070'|
    'MNPG_071';

export default MainPageLayouts;
